import React from 'react';
import AuthenticatedApp from './AuthenticatedApp'

function App() {
  return (
      <div>
        <AuthenticatedApp/>
      </div>
  );
}

export default App;
